// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Actions from "../actions"
import * as UserCuesSlice from "../slice"
import { debug } from "app/logging"
import { executorMutation, Init, userCuesService } from "../../../app/rpc"
import { CreateUserCueRequestSchema, UserCue } from "../../../generated/wisetime/user/cues/v4/user_cues_pb"

type CreateUserCueRpc = (request: Init<typeof CreateUserCueRequestSchema>) => Observable<UserCue>

export const createUserCue = (createUserCueRpc: CreateUserCueRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.createUserCue.match),
      mergeMap(({ payload: request }) =>
        createUserCueRpc(request)
          .pipe(
            map(UserCuesSlice.createUserCue),
            catchError(_ => {
              debug("Failed to create user cue")
              return of(Actions.createUserCueFailed)
            })
          )
      )
    )

const createUserCueRpc = (request: Init<typeof CreateUserCueRequestSchema>): Observable<UserCue> =>
  executorMutation(() => userCuesService.createUserCue(create(CreateUserCueRequestSchema, request)))

export default createUserCue(createUserCueRpc)
